import React from "react";

import { ApplicantUserCitizenship, ApplicantUserContactInformation, ApplicantUserIdentityDetails, ApplicantUserProfessional, CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryDocument, Entity } from "../../../../../../generated";
import { useQuery } from "@apollo/client";
import { lookupCountryQuery } from './identity-verification-archive-country-query'
import { ComponentQueryLoader } from "../../../../../shared/component-query-loader";
import { CollapsibleApplicantProfile } from "../../../../../shared/collapsible-applicant-profile/collapsible-applicant-profile";
import { Country } from "../../../../../../types/country";

interface CollapsibleApplicantProfileArchivedContainerProps {
  caseId: string;
}

export const CollapsibleApplicantProfileArchivedContainer: React.FC<
CollapsibleApplicantProfileArchivedContainerProps
> = (props) => {
  const {
    data: countryData,
    loading: countryLoading,
    error: countryError,
  } = useQuery(lookupCountryQuery);

  const {
    data: applicantDetailData,
    loading: applicantDetailLoading,
    error: applicantDetailError,
  } = useQuery(
    CasesIdentityVerificationCollapsibleApplicantProfileArchivedContainerArchivedIdentityVerificationCaseSummaryDocument,
    {
      variables: {
        archivedIdentityVerificationCaseSummaryId: props.caseId,
      },
      context: {
        headers: {
          "cache-enabled": "true",
        },
      },
    }
  );
  

  return (
    <ComponentQueryLoader
      loading={applicantDetailLoading || countryLoading}
      hasData={applicantDetailData}
      error={applicantDetailError || countryError}
      hasDataComponent={
        <CollapsibleApplicantProfile
          professional={applicantDetailData?.archivedIdentityVerificationCaseSummary?.applicant?.personalInformation?.professional as ApplicantUserProfessional}
          contactInformation={applicantDetailData?.archivedIdentityVerificationCaseSummary?.applicant?.personalInformation?.contactInformation as ApplicantUserContactInformation}
          identityDetails={applicantDetailData?.archivedIdentityVerificationCaseSummary?.applicant?.personalInformation?.identityDetails as ApplicantUserIdentityDetails}
          citizenship={applicantDetailData?.archivedIdentityVerificationCaseSummary?.applicant?.personalInformation?.citizenship as ApplicantUserCitizenship} 
          applyingTo={applicantDetailData?.archivedIdentityVerificationCaseSummary?.applicant?.personalInformation?.applyingTo as Entity[]}  
          countryData={
            countryData?.countries?.eventPayload?.countries as Country[]
          }
        />
      }
    />
  );
};
